export default __webpack_public_path__ + "static/media/Financial.d718874c.png";